import React from 'react'
import UserManagement from '../features/user-management/user-management'

const UserManagements = () => {
  return (
    <div>
        <UserManagement/>
    </div>
  )
}

export default UserManagements